import styled from 'styled-components';
import {
	WebOnlineProductGroupQuery,
	WebOnlineProductGroupsQuery
} from '../../../graphql';

type CategoryGroups =
	| WebOnlineProductGroupQuery['webOnlineProductGroup']['children']
	| WebOnlineProductGroupsQuery['webOnlineProductGroups'];

type CategoryProps = {
	category: CategoryGroups;
	selectCategory: (id: string) => void;
	large?: boolean;
};

export const CategoryCard = ({
	category,
	selectCategory,
	large = false
}: CategoryProps): JSX.Element => {
	const handleClick = (
		e: React.MouseEvent,
		id: string,
		categoryName: string
	) => {
		e.preventDefault();
		let pixel: string | undefined = undefined;
		switch (categoryName) {
			case 'Featured Items':
				pixel =
					'https://insight.adsrvr.org/track/pxl/?adv=xwyhvtq&ct=0:0qty8zb&fmt=3';
				break;
			case 'Drinks':
				pixel =
					'https://insight.adsrvr.org/track/pxl/?adv=xwyhvtq&ct=0:jmw2323&fmt=3';
				break;
			case 'Food':
				pixel =
					'https://insight.adsrvr.org/track/pxl/?adv=xwyhvtq&ct=0:0tp2dwu&fmt=3';
				break;
			case 'Kids Menu':
				pixel =
					'https://insight.adsrvr.org/track/pxl/?adv=xwyhvtq&ct=0:apjdgl8&fmt=3';
				break;
			case 'BIGGBY At Home':
				pixel =
					'https://insight.adsrvr.org/track/pxl/?adv=xwyhvtq&ct=0:rku0srm&fmt=3';
				break;
			default:
				pixel = undefined;
				break;
		}
		// Fire TTD Pixel
		if (pixel) {
			const img = new Image();
			img.src = pixel;
		}

		selectCategory(id);
	};

	return (
		<CategoryContainer large={large}>
			{category &&
				category
					.filter(({ isVisible }) => isVisible)
					.map(({ id, name, image }, key) => (
						<Container
							onClick={e => handleClick(e, id, name)}
							key={key}
						>
							<CategoryImage
								large={large}
								src={image}
								alt={name}
							></CategoryImage>
							<CategoryName>{name}</CategoryName>
						</Container>
					))}
		</CategoryContainer>
	);
};

const CategoryContainer = styled.div<{ large: boolean }>`
	display: grid;
	/* grid-template-columns: ${({ large }) =>
		large ? 'repeat(auto-fill, 455px)' : 'repeat(auto-fill, 300px)'}; */
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 48px;
	justify-content: space-between;
	padding-bottom: 48px;
	@media (max-width: 768px) {
		grid-template-columns: 1fr 1fr;
		grid-gap: 24px;
	}
	@media (max-width: 768px) {
		grid-gap: 16px;
	}
`;

const Container = styled.div`
	min-height: 130px;
	cursor: pointer;
	background: #fdfdfd;
	border-radius: 4px;
	transition: 0.3s;
	box-shadow: 0px 1px 2px rgba(17, 11, 11, 0.25);
	&:hover {
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
	}
`;

const CategoryImage = styled.img<{ large: boolean }>`
	width: 100%;
	height: 80%;
	max-height: 300px;
	object-fit: cover;
	@media (max-width: 992px) {
		height: 75%;
	}
`;

const CategoryName = styled.div`
	height: 20%;
	font-weight: 500;
	font-size: 20px;
	line-height: 120%;
	padding: 16px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	@media (max-width: 992px) {
		font-size: 18px;
		height: 25%;
	}
	@media (max-width: 480px) {
		font-size: 14px;
	}
`;
